import { render } from "./NoDataAvailable.vue?vue&type=template&id=033259fa"
import script from "./NoDataAvailable.vue?vue&type=script&lang=js"
export * from "./NoDataAvailable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__